import { render, staticRenderFns } from "./exportTraderDialog.vue?vue&type=template&id=72620280&scoped=true"
import script from "./exportTraderDialog.vue?vue&type=script&lang=js"
export * from "./exportTraderDialog.vue?vue&type=script&lang=js"
import style0 from "./exportTraderDialog.vue?vue&type=style&index=0&id=72620280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72620280",
  null
  
)

export default component.exports